import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
import { Tooltip, TooltipContent, TooltipTrigger } from '@fortem-monorepo/react-ui';
export const AppSidebarTooltip = ({ popoverOpen, tooltip, children, }) => {
    return (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: children }), _jsx(TooltipContent, { side: "right", align: "center", className: cn({
                    hidden: !!popoverOpen,
                }), children: tooltip })] }));
};
